import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trending-4, chart"><path d="M2.75 4.75V19.25H21.25M6.75 15.25L11 11L13 13L18.7538 7.24623M14.75 6.75H19.25V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTrending4;
